import React from 'react';
import { Icon } from './Icon.js';
export const IconItinerary5Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "11", y: "11", width: "5.5", height: "5.5", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("circle", { cx: "4.25", cy: "4.25", r: "2.75", fill: "currentColor" }),
        React.createElement("path", { d: "M9.25,13h-3c-.689,0-1.25-.561-1.25-1.25v-3c0-.414-.336-.75-.75-.75s-.75,.336-.75,.75v3c0,1.517,1.233,2.75,2.75,2.75h3c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconItinerary5Fill18.js.map